import { useState } from "react";
import { motion } from "framer-motion";
import { LuMailWarning } from "react-icons/lu";
import FloatingInput from "../../../common/FloatingInput";
import Button from "../../../common/Button";
import { containerVariants, itemVariants } from "../../../common/MotionVariants";

export default function ForgotPassword({ onSubmit, loading, onBack }) {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="flex flex-col gap-5"
      noValidate
      variants={containerVariants}
      initial="hidden"
      animate="show"
    >
      <motion.p variants={itemVariants} className="text-sm text-slate-400">
        Enter the email address on your account and we'll send you a token to
        reset your password.
      </motion.p>

      <motion.div variants={itemVariants}>
        <FloatingInput
          id="reset-email"
          label="Email address"
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />
      </motion.div>

      <motion.div variants={itemVariants}>
        <Button type="submit" icon={LuMailWarning} variant="accent" loading={loading}>
          Send reset token
        </Button>
      </motion.div>
    </motion.form>
  );
}